import {PlayerReduxDispatch, PlayerReduxState} from "../types";
import {MutationEducationSessionStartArgs,
  ChallengeMode, MutationEducationStartRpgPracticeArgs} from "../../../schema";
import {sessionStartMutation, sessionStartRpgPracticeMutation} from "../graphql";
import {analyticsSendEvent} from "../../../libs/analytics";

export default function start() {
  return (dispatch: PlayerReduxDispatch, getState: () => PlayerReduxState) => {
    const state = getState();

    state.client
      .mutate<any, MutationEducationSessionStartArgs>({
        mutation: sessionStartMutation,
        variables: {
          challengeId: state.challengeId,
          preview: state.isPreview,
          externalUserId: state.externalUserId,
          utm: state.utm,
        },
      })
      .then((result) => {
        if (!result || !result.data || !result.data.sessionStartResult) {
          throw new Error("Cannot start education session");
        }

        const sessionId = result.data.sessionStartResult.sessionId;
        const recognitionEngine = result.data.sessionStartResult.recognitionEngine ?? undefined;

        analyticsSendEvent("playerStart", {
          sessionId,
          challengeId: state.challengeId,
          preview: state.isPreview,
          externalUserId: String(state.externalUserId),
          recognitionEngine,
        });

        const startSession = (initAgentAction?: PlayerReduxState["initAgentAction"]) => {
          dispatch({
            type: "start",
            payload: {
              sessionId,
              recognitionEngine,
              ...(initAgentAction !== undefined ? {initAgentAction} : {}),
            },
          });
        };
        // TODO
        if (state.challenge?.mode === ChallengeMode.RPG_MODE) {
          return state.client
            .mutate<any, MutationEducationStartRpgPracticeArgs>({
              mutation: sessionStartRpgPracticeMutation,
              variables: {sessionId},
            })
            .then((rpgResult) => {
              const rpg = rpgResult?.data?.result;
              if (!rpg?.isStarted) {
                throw new Error("Cannot start RPG practice session");
              }
              const initAgentAction =
                rpg.avatarText || rpg.avatarAudio
                  ? {
                      url: rpg.avatarAudio ?? undefined,
                      text: rpg.avatarText ?? undefined,
                      index: 0,
                      uuid: "0",
                      played: false,
                    }
                  : undefined;
              startSession(initAgentAction);
            });
        }

        startSession();
      })
      .catch(() => {
        dispatch({
          type: "update",
          payload: {
            sessionStartFailed: true,
          },
        });
      });
  };
}
